/**
 * Pure helpers for the Memory tab's project sections (`StorageUsageView`).
 *
 * They live here rather than in the component for the reason `storageDrain.js` does:
 * `StorageUsageView` imports react-router and cannot be rendered under jest, so
 * anything worth pinning has to be a pure sibling.
 */

/**
 * Partition `GET /api/account/storage`'s one `projects` array into the user's own
 * projects and the Quality Check RUN projects, preserving the backend's
 * byte-descending order within each.
 *
 * A run project is a REAL project row (`system: true` + `qualityCheckEntryId`)
 * created per check run and hidden from the dashboard — its storage is genuine and
 * still counts toward the total, so the inventory reports it; keeping it out of the
 * Projects section is what makes that section's count mean "my projects".
 *
 * A row whose `kind` is missing or unrecognised counts as an ORDINARY project. The
 * frontend can be newer than the API (a partial deploy, or a cached bundle), and
 * silently dropping such rows would hide storage the user is paying for.
 */
export function splitProjectsByKind(projects) {
  const all = projects || [];
  return {
    projects: all.filter((p) => p?.kind !== 'qualityCheck'),
    qualityChecks: all.filter((p) => p?.kind === 'qualityCheck'),
  };
}

/**
 * Which project a Quality Check run was captured from — the source project's name
 * while it still exists, else its bare id, else null (an entry row the purge missed).
 * Never a fabricated name: a deleted source project is exactly the case a user needs
 * to be able to recognise.
 */
export function qualityCheckOrigin(qc) {
  if (!qc) return null;
  return qc.sourceProjectName || qc.sourceProjectId || null;
}
